module.exports = {
    rootUrl: process.env.REACT_APP_API_URL,
    altUrl: "http://mcc-portal-tasks.herokuapp.com",
    googleMaps: process.env.REACT_APP_GMAPS_API_KEY
}